<template>
  <div
    v-if="collections && collections.length > 0"
    class="c-collection-carousel"
    role="slider"
  >
    <client-only>
      <flickity
        v-if="flickityActive"
        ref="flickity"
        class="flickity"
        :options="flickityOptions"
      >
        <template v-for="collection in collections">
          <div
            :key="collection.id"
            class="carousel-cell"
          >
            <product-carousel-card v-bind="collection" />
          </div>
        </template>
      </flickity>
      <div
        v-else
        class="l-flex"
      >
        <template v-for="collection in collections">
          <div
            :key="collection.id"
            class="c-collection-carousel__item"
          >
            <product-carousel-card v-bind="collection" />
          </div>
        </template>
      </div>
    </client-only>
  </div>
</template>

<script>
import flickityActive from './flickityActive'
export default {
  mixins: [
    flickityActive
  ],
  props: {
    collections: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        freeScroll: true,
        imagesLoaded: true,
        // any options from Flickity can be used
        // https://flickity.metafizzy.co/options.html
      }
    }
  },
  watch: {
    async collections() {
      await this.$nextTick()
      this.flickityActivator()
    }
  },
  methods: {
    flickityActivator() {
      if (this.collections.length > 5) {
        this.flickityActive = true;
        return
      }
      if (window.innerWidth < 1100) {
        if (this.collections.length > 4) {
          this.flickityActive = true;
          return
        }
      }
      if (window.innerWidth < 800) {
        if (this.collections.length > 3) {
          this.flickityActive = true;
          return
        }
      }
      if (window.innerWidth < 600) {
        if (this.collections.length > 2) {
          this.flickityActive = true;
          return
        }
      }
      if (window.innerWidth < 400) {
        if (this.collections.length > 1) {
          this.flickityActive = true;
          return
        }
      }
      this.flickityActive = false;
      return
    }
  }
}
</script>

<style lang="scss">
  /* external css: flickity.css */
  .c-collection-carousel {
    max-width: rem(1300px);
    margin: auto;

    &__item {
      &:not(:last-child) {
        margin-right: rem(60px);
      }
    }
  }

  //flickity class override
  .c-collection-carousel {
    .flickity {
      &:focus-visible {
        outline: none !important;
      }
    }
    .flickity-enabled.is-draggable {
      padding-left: 30px;
      padding-right: 30px;
      margin: auto;
      max-width: rem(1100px);
    }
    .carousel-cell {
      height: auto;
      min-height: rem(270px);
      margin-right: rem(10px);
      border-radius: 5px;
      width: 250px;

      @include respond(phone) {
        width: 170px;
      }
      border-radius: 5px;
      counter-increment: gallery-cell;
    }

    button.flickity-button.flickity-prev-next-button.previous {
      background: transparent;
    }
    .flickity-prev-next-button.previous svg.flickity-button-icon {
      left: 0;
    }
    .flickity-prev-next-button.next svg.flickity-button-icon {
      right: 0;
      @include themify($themes) {
        color: themed('foreground');
      }
    }
    // prev and next buttons
    .flickity-prev-next-button {
      top: 50%;
    }
    .flickity-prev-next-button svg.flickity-button-icon {
      left: 100%;
      @include themify($themes) {
        color: themed('foreground');
      }
    }
    .flickity-button {
      background: transparent;
      &:hover {
        background: transparent;
      }
    }
    button.flickity-prev-next-button {
      width: 55px;
      height: 55px;
    }

  }
</style>
